module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-top-metals.8c4058c2.png";